import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 134px;
  height: 36px;
  border-radius: 4px;
  box-sizing: border-box;
`;
